import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import LockResetOutlinedIcon from "@mui/icons-material/LockResetOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import VolumeOffOutlinedIcon from "@mui/icons-material/VolumeOffOutlined";
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import { reduce } from "et3-type-guards";
import { fontWeights, sizes } from "et3-ui-library";

import { PROFILE_DROPDOWN_INFO_ROWS } from "../../constants/core-constants";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreLoginStore from "../../stores/core/core-login-store";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import { getNotificationSoundStore } from "../../stores/notification-store/notification-sound-store";

const ProfileDropdown = withLiteObserverAndTheme<{
  anchorEl: () => HTMLElement | null;
}>((props) => {
  const { anchorEl } = props;
  const { isProfileDropdownVisible, closeProfileDropdown, goToChangePassword } =
    getCoreUIStore();
  const user = getCorePersonalStore().user.get();
  const name = reduce(() => user.fullName, "Full Name");
  const role = reduce(() => user.role, "");
  const lastLogin = reduce(() => user.lastLogin, "Last login");
  const isSoundEnabled = getNotificationSoundStore().isSoundEnabled.get();

  return (
    <Menu
      anchorEl={anchorEl}
      open={isProfileDropdownVisible.get()}
      onClose={closeProfileDropdown}
      slots={{ transition: Fade }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{ paper: { sx: { width: sizes.drawerWidth } } }}
    >
      <Box sx={{ px: 2.5, py: 1.5 }}>
        <Typography
          variant="subtitle1"
          fontWeight={fontWeights.semibold}
          noWrap
        >
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {role}
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ px: 2.5, py: 1 }}>
        {PROFILE_DROPDOWN_INFO_ROWS(lastLogin).map((row) => (
          <Typography key={row.titleKey} variant="body2" color="text.secondary">
            {i18n.get(row.titleKey)}: {row.value}
          </Typography>
        ))}
      </Box>
      <Divider />
      <MenuItem
        role="menuitemcheckbox"
        aria-checked={isSoundEnabled}
        onClick={() => getNotificationSoundStore().toggleSound()}
      >
        <ListItemIcon>
          {isSoundEnabled ? <VolumeUpOutlinedIcon /> : <VolumeOffOutlinedIcon />}
        </ListItemIcon>
        <ListItemText>{i18n.get("NOTIFICATION_SOUND")}</ListItemText>
      </MenuItem>
      <MenuItem onClick={goToChangePassword}>
        <ListItemIcon>
          <LockResetOutlinedIcon />
        </ListItemIcon>
        <ListItemText>{i18n.get("CHANGE_PASSWORD")}</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => getCoreLoginStore().signOutHandler()}>
        <ListItemIcon>
          <LogoutOutlinedIcon />
        </ListItemIcon>
        <ListItemText>{i18n.get("SIGN_OUT")}</ListItemText>
      </MenuItem>
    </Menu>
  );
});
export default ProfileDropdown;
